<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!-- logo -->
          <b-img
            :src="require('@/assets/images/logo/PRYM-blue-small.png')"
            height="50%"
            alt="PRYM Logo"
          />
        </b-link>

        <b-card-title class="mb-1">
          Forgot Password? 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          Enter your email and we'll send you instructions to reset your password
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
            class="auth-forgot-password-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- email -->
            <b-form-group
              label="Email"
              label-for="forgot-password-email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="forgot-password-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false:null"
                  name="forgot-password-email"
                  placeholder="john@example.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-danger"> {{ forgorPasswordError }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              block
              type="submit"
            >
              Send reset link
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <b-link :to="{name:'auth-login'}">
            <feather-icon icon="ChevronLeftIcon" /> Back to login
          </b-link>
        </b-card-text>

      </b-card>
    <!-- /Forgot Password v1 -->
    </div>
    <b-modal
      id="modal-forgot-password"
      title="Forgot Password"
      centered
    >
      <b-card-text class="text-center">
        <p class="mb-0">
          We have sent you an email with a verification code.
        </p>
      </b-card-text>

      <b-col
        class="d-flex text-center mb-1 justify-content-center"
      >
        <CodeInput
          class="input"
          @complete="onComplete"
        />

      </b-col>

      <!-- Request a new code -->
      <b-card-text class="text-center mt-1 mb-0">
        <b-link
          @click="requestNewCode"
        >
          Request a new code
        </b-link>

      </b-card-text>
      <b-card-text class="text-center">
        <small>
          {{ requestNewCodeMessage }}
        </small>
      </b-card-text>

      <!-- password -->
      <b-form>
        <b-form-group>
          <b-form-input
            id="username"
            v-model="userEmail"
            name="username"
            placeholder="Username"
            autocomplete="username"
            hidden
          />
          <label>Password</label>
          <validation-provider
            #default="{ errors }"
            rules="required|password"
            name="new-password"
            vid="password"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid':null"
            >
              <b-form-input
                id="new-password"
                v-model="password"
                name="new-password"
                placeholder="Enter new password"
                autocomplete="new-password"
                :type="passwordFieldType"
                :state="errors.length > 0 ? false:null"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIcon"
                  class="cursor-pointer"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

          <!-- confirm password -->
          <div class="mt-1">
            <label>Confirm Password</label>
            <validation-provider
              #default="{ errors }"
              rules="required|confirmed:password"
              name="Confirm Password"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid':null"
              >
                <b-form-input
                  v-model="passwordConfirm"
                  :type="passwordFieldType"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Repeat Password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>

        </b-form-group>
      </b-form>
      <small class="text-danger"> {{ changePasswordError }}</small>
      <template #modal-footer>
        <b-button
          variant="primary"
          block
          show
          @click="changePassword"
        >
          Change Password
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BForm, BButton, BImg, BModal, BCol, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { Auth } from 'aws-amplify'
import CodeInput from 'vue-verification-code-input'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    BImg,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    BModal,
    ValidationProvider,
    ValidationObserver,
    CodeInput,

    BCol,
    BInputGroupAppend,
    BInputGroup,

  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      // validation
      required,
      email,
      password: '',
      passwordConfirm: '',
      forgorPasswordError: '',
      changePasswordError: '',
      code: '',
      requestNewCodeMessage: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          Auth.forgotPassword(this.userEmail)
            .then(() => {
              this.$bvModal.show('modal-forgot-password')
            })
            .catch(err => {
              this.forgorPasswordError = err.message
            })
        }
      })
    },
    requestNewCode() {
      Auth.forgotPassword(this.userEmail)
        .then(() => {
          this.requestNewCodeMessage = `New code sent to ${this.userEmail}`
        })
        .catch(err => {
          this.forgorPasswordError = err.message
        })
    },
    onComplete(value) {
      this.code = value
    },
    changePassword() {
      Auth.forgotPasswordSubmit(this.userEmail, this.code, this.password)
        .then(() => {
          // push to login with param Email
          this.$router.push({ name: 'auth-login', params: { email: this.userEmail } })
          this.$bvModal.hide('modal-forgot-password')
        })
        .catch(err => {
          this.changePasswordError = err.message
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
